<div class="ib-biometric">
  <div class="ib-biometric--w-list">
    <div class="ib-biometric__box ib-biometric__box--w-app-link">
      <span class="ib-biometric__icon ib-biometric__icon--red"><span class="icon-biometria"></span></span>
      <div class="ib-biometric__box--container-type2">
        <p>
            <span class="ib-biometric__box--text ib-biometric__box--text-w-list">
                <span>{{'BIOMETRIC_BOARDING_CONFIRMATION_BOX_TEXT' | translate}}</span>
            </span>
        </p>
        <div class="ib-biometric__box--link">
          <a class="link link__regular link__regular--underline link__regular--important link__regular--single-arrow link__icon--arrow" href="{{'BIOMETRIC_LANDING_LINK'|link}}" target="_blank">{{'APIS_NOT_ALLOWED_MORE_INFORMATION_LINK'|translate}}</a>
          <span class="icon-flecha_1_derecha"></span>
        </div>
      </div>
    </div>
    <div class="ib-biometric-available-banner">
        <header class="ib-biometric-available-banner__header">
            <h2 class="ib-biometric-available-banner__header-title">{{'BIOMETRIC_BOARDING_FACIAL_RECOGNITION_APPS_TITLE'|translate}}</h2>
        </header>
        <section class="ib-biometric-available-banner__body">
            <p class="ib-biometric-available-banner__body-title">{{'BIOMETRIC_BOARDING_FACIAL_RECOGNITION_APPS_SUBTITLE'|translate}}
            </p>
            <div class="ib-biometric-available-banner__body-content">
                <div class="ib-biometric-available-banner__body-col">
                    <p class="ib-biometric-available-banner__body-col-title">{{'BIOMETRIC_BOARDING_FACIAL_RECOGNITION_APPS_OPTION_1'|translate}}</p>
                    <p class="ib-biometric-available-banner__body-col-text">{{'BIOMETRIC_BOARDING_MODAL_TEXT_4'|translate}}</p>
                    <div class="ib-biometric-available-banner__body-buttons">
                        <a focusin class="ib-link" href="https://play.google.com/store/apps/details?id=com.iberia.android"><img src="{{ baseImagePath }}/logos/googleplay.jpg" alt="Google Play"/></a>
                        <a focusin class="ib-link" href="https://itunes.apple.com/es/app/iberia/id434825954?mt=8"><img src="{{ baseImagePath }}/logos/appstore.jpg" alt="App Store"/></a>
                    </div>
                </div>
                <div class="ib-biometric-available-banner__body-col">
                    <p class="ib-biometric-available-banner__body-col-title">{{'BIOMETRIC_BOARDING_MODAL_DESK_TITLE_V2'|translate}}</p>
                    <p class="ib-biometric-available-banner__body-col-text">{{'BIOMETRIC_BOARDING_MODAL_DESK_DESCRIPTION_V2'|translate}}</p>
                </div>
            </div>
        </section>
    </div>
  </div>
</div>
